import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiPopover = {
  defaultProps: { disableScrollLock: true, elevation: 16 },
  styleOverrides: { paper: { border: '1px solid var(--mui-palette-divider)' } },
} satisfies Components<Theme>['MuiPopover'];
